<template>
  <div class="home">
    <div>
      <div>
        <div class="filterable-content wrap-on-mobile reversed">
          <div class="left-part flex-width300">
            <h2>Football Home</h2>
            <loading-state :state="menuState"></loading-state>
            <div class="group" v-if="tournaments.length">
              <ul>
                <li 
                  v-for="tournament in tournaments"
                  :key="tournament.key"
                  class="tag">
                    <div class="">
                      <router-link
                        :to="{ name: 'tournament', params: {key: tournament.key}}"
                        class="clean">{{tournament.short_name}}</router-link>
                    </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="right-part">
            <loading-state :state="state"></loading-state>
            <div v-if="matches" class="sub-content">
              <section v-for="kind in listNames" :key="kind.status" v-if="matches[kind.status] && matches[kind.status].length">
                <h2>Featured {{kind.name}}</h2>
                <div class="sub-content">
                  <div class="item link" v-for="match in matches[kind.status]" :key="match.info.key">
                    <football-match-mini :match="match"></football-match-mini>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { FootballMatch } from '@/models/match'
import { FootballTournament } from '@/models/tournament'
import { DataState } from '@/state'

export default {
  name: 'home',
  data () {
    return {
      tournaments: [],
      listNames: [
        { name: 'Live', status: 'started' },
        { name: 'Upcoming', status: 'not_started' },
        { name: 'Completed', status: 'completed' }
      ],
      matches: {},
      state: DataState.newLoading(),
      menuState: DataState.newLoading()
    }
  },
  created () {
    FootballMatch.homePage().then((matches) => {
      this.matches = matches
      // this.seasons = response.recentSeasons
      this.state.changeToLoaded()
    }).catch((error) => {
      this.state.changeToError(error)
    })

    FootballTournament.recent().then(tournaments => {
      this.tournaments = tournaments
      this.menuState.changeToLoaded()
    }).catch((error) => {
      this.menuState.changeToError(error)
    })
  },
  methods: {
  }
}
</script>
